import { render, staticRenderFns } from "./FpuiInputNumber.vue?vue&type=template&id=447df153&lang=pug&"
import script from "./FpuiInputNumber.vue?vue&type=script&lang=js&"
export * from "./FpuiInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./FpuiInputNumber.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports